import { Http } from '../../shared';
import { settings } from '../../settings';

export class StopService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }

    async search(query) {
        var response = await this.http.get(`${this.service_url}/stops?${new URLSearchParams(query)}`);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }
}
